import type { FieldValues, UseFormWatch } from 'react-hook-form';
import type { UnsavedChangesModalOptions } from '@/app/components/UnsavedChangesModal/types';
import { useFormCompletionStatus } from '@/hooks/useFormCompletionStatus';

export const useGetConfirmationModalContent = <T extends FieldValues>(
  isDirty: boolean,
  watch: UseFormWatch<T>,
  requiredKeys: readonly string[]
): UnsavedChangesModalOptions => {
  const { isAllRequiredFilled } = useFormCompletionStatus<T>(watch, requiredKeys);

  if (!isAllRequiredFilled) {
    return {
      title: 'Leave this page?',
      description:
        'You haven’t completed the required primary passenger details yet. If you leave now, the client won’t be created, but your progress will be saved as a draft and can be completed later.',
      cancelButtonText: 'Leave this Page',
      discardButtonText: 'Cancel',
      onCancel: ({ onSave }) => {
        onSave?.();
      },
      onDiscard: ({ onCancel }) => {
        onCancel?.();
      },
    };
  }

  if (isAllRequiredFilled && isDirty) {
    return {
      title: 'Leave this page?',
      description:
        'Required details are saved as a draft. The client setup is not finalized yet and can be completed later from the client profile.',
      cancelButtonText: 'Leave this Page',
      discardButtonText: 'Cancel',
      onCancel: ({ onSave }) => {
        onSave?.();
      },
      onDiscard: ({ onCancel }) => {
        onCancel?.();
      },
    };
  }

  return {
    title: 'Leave this page?',
    description:
      'Required details are saved as a draft. The client setup is not finalized yet and can be completed later from the client profile.',
    cancelButtonText: 'Leave this Page',
    discardButtonText: 'Cancel',
    onCancel: ({ onSave }) => {
      onSave?.();
    },
    onDiscard: ({ onCancel }) => {
      onCancel?.();
    },
  };
};
